import { N05_02 } from "./N05_02";
import { N05_06 } from "./N05_06";

export const N05_01 = {
  selectedValueColumn: "ItemCode",
  selectedTitle: "Region",
  visuals: [
    {
      title: "Region",
      visual: [
        {
          columns: 12,
          rows: 2,
          visual: {
            id: 1,
            type: "advancedTable",
            colorTheme: "colorTheme1",
            title: "Region",
            binding: {
              data: {
                columns: [
                  {
                    name: "Region",
                    columnName: "RegionName",
                    width: "450px",
                    align: "left",
                    sortable: true,
                  },
                  {
                    name: "Number Of Branches",
                    columnName: "NumberOfBranches",
                    width: "350px",
                    align: "center",
                    sortable: true,
                  },
                ],
                title: "RegionName",
                endpoint: "N05.1",
                parameters: [
                  { key: "CycleCode", value: "CP1" },
                  { key: "CycleYear", value: "2026" },
                  { key: "ItemCode", value: "" },
                ],
              },
              context: {
                point: {
                  onClick: N05_02,
                },
              },
            },
          },
        },
      ]
    },
    {
      title: "Agent",
      visual: [
        {
          columns: 12,
          rows: 2,
          visual: {
            id: 1,
            type: "advancedTable",
            colorTheme: "colorTheme1",
            title: "Agent",
            binding: {
              data: {
                columns: [
                  {
                    name: "Agent Name",
                    columnName: "AgentName",
                    width: "300px",
                    align: "left",
                    sortable: true,
                    sum: false,
                  },
                  {
                    name: "Territory",
                    columnName: "TerritoryName",
                    width: "300px",
                    align: "left",
                    sortable: true,
                    sum: false,
                  },
                  {
                    name: "Number Of Branches",
                    columnName: "NumberOfBranches",
                    width: "300px",
                    align: "center",
                    sortable: true,
                    sum: false,
                  },
                ],
                title: "AgentName",
                endpoint: "N05.5",
                parameters: [
                  { key: "CycleCode", value: "CP1" },
                  { key: "CycleYear", value: "2026" },
                  { key: "ItemCode", value: "" },
                ],
              },
              context: {
                point: {
                  onClick: N05_06,
                },
              },
            },
          },
        },
      ]
    },
  ],
};
